import React from 'react';
import { toast } from 'react-toastify';

const TabNavigation = ({ tabs, activeTab, setActiveTab, validateForm, errors, isSubmitting, formikProps }) => {
  // Function to handle tab click with validation
  const handleTabClick = async (index) => {
    // Only allow going back to previous tabs or staying on current tab
    if (index <= activeTab) {
      setActiveTab(index);
      return;
    }

    // If trying to move forward, validate the current tab first
    if (index > activeTab) {
      // Validate the current form
      const formErrors = await formikProps.validateForm();

      // If there are no errors in the current tab, allow navigation
      if (Object.keys(formErrors).length === 0) {
        setActiveTab(index);
      } else {
        // Otherwise, stay on the current tab (validation errors will be shown)
        // console.log('Please fill all required fields before proceeding');
        toast.error('Please fill all required fields before proceeding');

      }
    }

    if (!formikProps?.validateForm) return;

    const errors = await formikProps.validateForm();
    if (Object.keys(errors).length === 0) {
      setActiveTab(index);
    }
  };

  return (
    <div className="w-full">
      {/* <div className="flex flex-wrap gap-2 overflow-x-auto">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => handleTabClick(index)}
            disabled={isSubmitting}
            className={`flex flex-col items-center justify-center min-w-[80px] px-2 py-1 text-sm rounded-md border 
              ${activeTab === index ? 'bg-black text-white' :
                index < activeTab ? 'bg-gray-200 text-gray-800' :
                  'bg-gray-200 text-gray-800 opacity-80'}`}
          >
            <span className="text-xs font-semibold">{index + 1}</span>
            <span className="text-xs truncate w-full">{tab.title}</span>
          </button>
        ))}
      </div> */}

      <div className="w-full h-1 bg-gray-300 mt-1">
        <div
          className="h-1 bg-black transition-all duration-300"
          style={{ width: `${(activeTab / (tabs.length - 1)) * 100}%` }}
        />
      </div>
    </div>
  );
};

export default TabNavigation;
